export const travelone = {
  companyName: 'FlySync',
  corporateName: 'Travelone',
  title: 'Travelone',
  templateConfig: 'template1',
  email: 'support@travelonego.com',
  phone: '+91 9789944601',
  address:
    'Kannaiah St, Darmapuram, T. Nagar, Chennai, Tamil Nadu 600017, India',
  apiUrl: 'https://admin.travelonego.com/backend/',
  isFullBGimage: 'Y',
  loginBanner: 'Y',
  whatsapp: '',
  poweredBy: false,
  agentNavigate: '',
  instagram: 'https://www.instagram.com/travelonego/',
  facebook: 'https://www.facebook.com/travelonego/',
  twitter: '',
  linkedin: '',
  youtube: '',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['TBO'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
